var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("p-pages--carrierPayment__icon--" + _vm.type)},[_c('i',{class:("fas " + _vm.iconClass + " fa-icon-style animated bounce")})])}
var staticRenderFns = []

export { render, staticRenderFns }